@if (!postStore.advanced()) {
    <div
        class="row align-items-center border-bottom py-2 gy-2 post-card border border-1 rounded mb-3"
        [class.border-danger-subtle]="!post.imInCharge && !post.userInChargeId"
        [class.border-success]="post.imInCharge || (!post.imInCharge && post.userInChargeId)"
        [class.taken]="post.userInChargeId"
        [class.mine]="post.imInCharge">
        <!-- Status chips -->
        <div class="col-6 col-md-4 col-lg-1 d-flex flex-wrap gap-1">
            <button
                [attr.aria-label]="'View post notes (' + sfNotes.count + ')'"
                class="btn-sm"
                [class.status-chip--warning]="sfNotes.count == 0"
                [class.status-chip--success]="sfNotes.count > 0"
                sfButton
                #sfNotes="sfNotes"
                sfNotes
                [initialCount]="post.postNotesCount"
                type="button"
                color="success"
                [postId]="post.id">
                <span class="status-chip__label"
                    ><fa-icon [icon]="['fas', 'sticky-note']"></fa-icon> {{ sfNotes.count }}</span
                >
            </button>

            @if (post.isUrgent) {
                <span class="status-chip status-chip--urgent" ngbTooltip="Urgent job" placement="top">
                    <fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon>
                    <span class="status-chip__label">URGENT</span>
                </span>
            }

            @if (post.postImagesCount) {
                <button
                    type="button"
                    class="status-chip status-chip--clickable"
                    [class.status-chip--success]="post.postImagesCount > 0"
                    [disabled]="loadingImages()"
                    ngbTooltip="{{ post.postImagesCount }} images attached"
                    placement="top"
                    (click)="openImages()">
                    @if (loadingImages()) {
                        <fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
                    } @else {
                        <fa-icon [icon]="['fas', 'image']"></fa-icon>
                    }
                    <span class="status-chip__label">{{ post.postImagesCount }}</span>
                </button>
            }

            @if (post.isBillable && !post.isInvoiced) {
                <span class="status-chip status-chip--warning" ngbTooltip="Invoice missing" placement="top">
                    <fa-icon [icon]="['fas', 'file-invoice']"></fa-icon>
                </span>
            }

            @if (post.isBillable && !post.isPaymentReceived) {
                <span class="status-chip status-chip--warning" ngbTooltip="Payment outstanding" placement="top">
                    <fa-icon [icon]="['fas', 'pound-sign']"></fa-icon>
                </span>
            }

            @if (post.isBillable && post.isPaymentExpected) {
                <span class="status-chip status-chip--danger" ngbTooltip="Payment expected on site" placement="top">
                    <fa-icon [icon]="['fas', 'credit-card']"></fa-icon>
                </span>
            }

            @if (post.isFreeOfCharge) {
                <span class="status-chip status-chip--info" ngbTooltip="Free of charge" placement="top">
                    <fa-icon [icon]="['fas', 'money-bill-transfer']"></fa-icon>
                </span>
            }

            @if (post.isWarranty) {
                <span class="status-chip status-chip--warranty" ngbTooltip="Main boiler under warranty" placement="top">
                    <fa-icon [icon]="['fas', 'star']"></fa-icon>
                </span>
            }

            @if (post.isGuarantee) {
                <span
                    class="status-chip status-chip--warranty"
                    ngbTooltip="Main boiler under guarantee"
                    placement="top">
                    <fa-icon [icon]="['fas', 'star']"></fa-icon>
                </span>
            }
        </div>

        <!-- Appointment type -->
        <div class="col-6 col-md-4 col-lg-1">
            <span class="d-md-none fw-semibold small text-body-secondary d-block">Appointment</span>
            {{ post.appointmentType }}
        </div>

        <!-- Post type -->
        <div class="col-6 col-md-4 col-lg-2">
            <span class="d-md-none fw-semibold small text-body-secondary d-block">Type</span>
            {{ post.postType }}
        </div>

        <!-- Customer -->
        <div class="col-12 col-md-6 col-lg-2 text-truncate">
            <a [routerLink]="['/customers', post.customerId]">
                {{ post.customerName }} -
                {{ post.customerAddressLine1 ?? '' | truncate: 20 }}
            </a>
        </div>

        <!-- Staff -->
        <div class="col-6 col-md-3 col-lg-1">
            <span class="d-md-none fw-semibold small text-body-secondary d-block">Staff</span>
            <a routerLink="/staff/{{ post.staffId }}">{{ post.staffName }}</a>
        </div>

        <!-- Assign to -->
        <div class="col-6 col-md-3 col-lg-2">
            <span class="d-md-none fw-semibold small text-body-secondary d-block">Assign to</span>
            <ng-select
                class="ng-select-dropdown-fit"
                [items]="postStore.assignToList()"
                bindValue="id"
                bindLabel="fullName"
                [(ngModel)]="post.userInChargeId"
                placeholder="Assign to..."
                (change)="assignPostToStaff($event)">
                <ng-option [value]="null">Unassigned</ng-option>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <sf-staff-select-option [staff]="item" showPicture showColour /> </ng-template
            ></ng-select>
        </div>

        <!-- Received date -->
        <div class="col-12 col-md-6 col-lg-1">
            <div class="text-body-secondary small ms-md-2" container="body">
                <b>{{ post.createdDate | date: 'dd/MM/yyyy' }}</b>
            </div>
            <div class="text-body-secondary small ms-md-2" container="body">
                <b>{{ post.createdDate | date: 'HH:mm:ss' }}</b>
            </div>
        </div>

        <!-- Actions -->
        <div class="col-12 col-lg-2">
            <div class="ms-lg-auto">
                <div class="btn-group btn-group-sm flex-wrap w-100 w-lg-auto">
                    <a sfButton icon="file-pdf" size="sm" tooltip="View the certificate" (click)="viewCertificate()"
                        >View</a
                    >

                    @switch (post.postTypeId) {
                        <!-- Quote Wizard -->
                        @case (51) {
                            <a
                                sfButton
                                icon="cog"
                                size="sm"
                                href="{{ legacyUrl }}WizardQuote/Edit/{{ post.t1 }}"
                                target="_blank"
                                >Process</a
                            >
                        }

                        <!-- Smart quote -->
                        @case (73) {
                            <a sfButton icon="cog" size="sm" routerLink="/smartquote/{{ post.t1 }}" target="_blank"
                                >Process</a
                            >
                        }
                        <!-- Smart quote -->
                        @case (74) {
                            <a sfButton icon="cog" size="sm" routerLink="/smartquote/{{ post.t1 }}" target="_blank"
                                >Process</a
                            >
                        }
                        @default {
                            <a sfButton icon="cog" size="sm" routerLink="/posts/{{ post.id }}">Process</a>
                        }
                    }

                    <div class="btn-group" ngbDropdown role="group" aria-label="Button group with nested dropdown">
                        <button
                            sfButton
                            type="button"
                            size="sm"
                            color="secondary"
                            class="dropdown-toggle-split"
                            ngbDropdownToggle></button>
                        <div class="dropdown-menu" ngbDropdownMenu>
                            @if (post.isVoided) {
                                <button
                                    sfButton
                                    ngbDropdownItem
                                    tooltip="Mark this post as Unvoided"
                                    (click)="postStore.setPostVoid({ postId: post.id, isVoid: false })">
                                    Unvoid
                                </button>
                            } @else {
                                <button
                                    sfButton
                                    ngbDropdownItem
                                    tooltip="Mark this post as Voided"
                                    (click)="postStore.setPostVoid({ postId: post.id, isVoid: true })">
                                    Void
                                </button>
                            }
                            <button
                                sfButton
                                ngbDropdownItem
                                tooltip="Remove this post (will mark the post as Processed)"
                                (click)="postStore.removePost(post.id)">
                                Remove
                            </button>
                            <button
                                sfButton
                                ngbDropdownItem
                                tooltip="Delete this post will remove it from your database (irreversable)"
                                (click)="deletePost()">
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
} @else {
    <div
        class="post-card border border-1 rounded mb-2"
        [class.border-danger-subtle]="!post.imInCharge && !post.userInChargeId"
        [class.border-success]="post.imInCharge || (!post.imInCharge && post.userInChargeId)"
        [class.taken]="post.userInChargeId"
        [class.mine]="post.imInCharge">
        @if (post.isVoided) {
            <span class="badge bg-danger post-status">VOIDED</span>
        }
        @if (post.isProcessed) {
            <span class="badge bg-success post-status">PROCESSED</span>
        }
        <div class="post-detail">
            @if (post.imInCharge) {
                <span class="post-detail__assigned bg-success">Assigned to me</span>
            }
            @if (!post.imInCharge && post.userInChargeId) {
                <span class="post-detail__assigned bg-warning">Assigned to {{ post.userInChargeName }}</span>
            }
            @if (!post.imInCharge && !post.userInChargeId) {
                <span class="post-detail__assigned bg-danger">Unassigned</span>
            }

            <div>
                <div class="d-flex justify-content-between align-items-center">
                    <p class="mb-0">
                        <span class="small text-body-secondary d-block fw-bold">
                            {{ post.appointmentType }}
                        </span>
                        <span
                            class="d-block fs-5"
                            [class.text-danger]="!post.userInChargeId"
                            [class.text-success]="post.userInChargeId"
                            ><b>{{ post.postType }}</b>
                        </span>
                        <span
                            class="d-block text-body-secondary small mb-1"
                            ngbTooltip="Received on {{ post.createdDate | date: 'dd/MM/yyyy HH:mm:ss' }}"
                            container="body"
                            >Received <b>{{ post.createdDate | date: 'dd/MM/yyyy HH:mm:ss' }}</b></span
                        >
                    </p>
                    <div class="align-content-end pe-0 pe-lg-4">
                        @if (post.isBillable) {
                            <span
                                class="status-chip"
                                [class.status-chip--success]="post.total > 0"
                                [class.status-chip--danger]="post.total === 0">
                                <fa-icon [icon]="['fas', 'pound-sign']"></fa-icon>
                                <span class="status-chip__label">{{ post.total | currency }}</span>
                            </span>
                        }
                    </div>
                </div>

                <div class="status-bar d-flex gap-2 flex-wrap align-items-center mt-2">
                    @if (post.isUrgent) {
                        <span class="status-chip status-chip--urgent" ngbTooltip="Urgent job" placement="top">
                            <fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon>
                            <span class="status-chip__label">URGENT</span>
                        </span>
                    }

                    @if (post.postImagesCount) {
                        <span
                            class="status-chip"
                            [class.status-chip--success]="post.postImagesCount > 0"
                            ngbTooltip="{{ post.postImagesCount }} images attached"
                            placement="top">
                            <fa-icon [icon]="['fas', 'image']"></fa-icon>
                            <span class="status-chip__label">{{ post.postImagesCount }}</span>
                        </span>
                    }

                    @if (post.isBillable && !post.isInvoiced) {
                        <span class="status-chip status-chip--warning" ngbTooltip="Invoice missing" placement="top">
                            <fa-icon [icon]="['fas', 'file-invoice']"></fa-icon>
                            <span class="status-chip__label">Invoice</span>
                        </span>
                    }

                    @if (post.isBillable && !post.isPaymentReceived) {
                        <span class="status-chip status-chip--warning" ngbTooltip="Payment outstanding" placement="top">
                            <fa-icon [icon]="['fas', 'pound-sign']"></fa-icon>
                            <span class="status-chip__label">Payment</span>
                        </span>
                    }

                    @if (post.isBillable && post.isPaymentExpected) {
                        <span
                            class="status-chip status-chip--danger"
                            ngbTooltip="Payment expected on site"
                            placement="top">
                            <fa-icon [icon]="['fas', 'credit-card']"></fa-icon>
                            <span class="status-chip__label">Expected</span>
                        </span>
                    }

                    @if (post.isFreeOfCharge) {
                        <span class="status-chip status-chip--info" ngbTooltip="Free of charge" placement="top">
                            <fa-icon [icon]="['fas', 'money-bill-transfer']"></fa-icon>
                            <span class="status-chip__label">FOC</span>
                        </span>
                    }

                    @if (post.isWarranty) {
                        <span
                            class="status-chip status-chip--warranty"
                            ngbTooltip="Main boiler under warranty"
                            placement="top">
                            <fa-icon [icon]="['fas', 'star']"></fa-icon>
                            <span class="status-chip__label">Warranty</span>
                        </span>
                    }

                    @if (post.isGuarantee) {
                        <span
                            class="status-chip status-chip--warranty"
                            ngbTooltip="Main boiler under guarantee"
                            placement="top">
                            <fa-icon [icon]="['fas', 'star']"></fa-icon>
                            <span class="status-chip__label">Guarantee</span>
                        </span>
                    }
                </div>
            </div>
            <div>
                <div class="d-flex flex-column small gap-1">
                    <span class="fw-bold">
                        <a [routerLink]="['/customers', post.customerId]">
                            {{ post.customerName }} -
                            {{ post.customerAddressLine1 ?? '' | truncate: 20 }}
                        </a></span
                    >
                </div>
            </div>
            <div class="d-none d-xl-block">
                @if (post.staffId) {
                    <div class="d-flex">
                        <img class="engineer-image" [src]="post.staffImage" [alt]="post.staffName" />
                        <span class="ms-3 small fw-bold"
                            >Posted By<br /><a routerLink="/staff/{{ post.staffId }}">{{ post.staffName }}</a></span
                        >
                    </div>
                }
            </div>
            <div class="d-none d-xl-block">
                @if (post.userInChargeId) {
                    <div class="d-flex border border-success border-2 rounded p-3 align-items-center">
                        @if (staffMap().get(post.userInChargeId)) {
                            <img
                                class="engineer-image"
                                [src]="staffMap().get(post.userInChargeId)!.picture"
                                [alt]="post.userInChargeName" />
                        }
                        <span class="ms-3 small fw-bold"
                            >Assigned to<br /><a routerLink="/staff/{{ post.userInChargeId }}">{{
                                post.userInChargeName ?? '' | truncate: 15
                            }}</a></span
                        >
                    </div>
                }
            </div>
            <!-- <div class="controls">
            <a sfButton type="button" size="sm" color="clear" icon="chevron-right" routerLink="/posts/{{ post.id }}"></a>
            <button sfButton type="button" size="sm" color="clear" icon="chevron-right" (click)="postClick()"></button>
        </div> -->
        </div>
        <div class="bottom-controls">
            <div class="row align-items-center">
                <ng-container *ngxPermissionsOnly="'ADMIN'">
                    <div class="col-6 col-md-auto">
                        <label class="small" [for]="'staff-for-post-' + post.id"
                            >{{ post.userInChargeId ? 'Assigned to' : 'Assign to' }}:</label
                        >
                    </div>

                    <div class="col-6 col-md-auto col-lg-4 col-xl-3 col-xxl-3">
                        <ng-select
                            class="ng-select-dropdown-fit"
                            [items]="postStore.staff()"
                            bindValue="id"
                            bindLabel="fullName"
                            [(ngModel)]="post.userInChargeId"
                            placeholder="Assign to..."
                            (change)="assignPostToStaff($event)">
                            <ng-option [value]="null">Unassigned</ng-option>
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                <span>{{ item.fullName }} ({{ item.id }})</span>
                            </ng-template></ng-select
                        >
                    </div>
                </ng-container>
                <ng-container *ngxPermissionsExcept="'ADMIN'">
                    <div class="col-12 col-md-auto text-center text-md-start">
                        @if (post.userInChargeId) {
                            <button
                                sfButton
                                type="button"
                                color="danger"
                                size="sm"
                                icon="unlink"
                                tooltip="Release this post"
                                (click)="unTakePost()">
                                Release
                            </button>
                        } @else {
                            <button
                                sfButton
                                type="button"
                                color="secondary"
                                size="sm"
                                icon="link"
                                tooltip="Take charge of this post"
                                (click)="takePost()">
                                Take
                            </button>
                        }
                    </div></ng-container
                >
                <div class="col-12 mt-3 mt-md-0 text-center text-md-end col-md-auto ms-md-auto">
                    <div class="btn-group btn-group-sm">
                        <button
                            sfButton
                            #sfNotes="sfNotes"
                            sfNotes
                            [initialCount]="post.postNotesCount"
                            type="button"
                            color="secondary"
                            icon="sticky-note"
                            [postId]="post.id">
                            Notes
                            @if (sfNotes.count) {
                                <span class="badge text-bg-danger">{{ sfNotes.count }}</span>
                            }
                        </button>

                        <a sfButton icon="file-pdf" size="sm" tooltip="View the certificate" (click)="viewCertificate()"
                            >View</a
                        >

                        @switch (post.postTypeId) {
                            <!-- Quote Wizard -->

                            @case (51) {
                                <a
                                    sfButton
                                    icon="cog"
                                    size="sm"
                                    [tooltip]="processTooltip"
                                    href="{{ legacyUrl }}WizardQuote/Edit/{{ post.t1 }}"
                                    target="_blank"
                                    >Process</a
                                >
                            }
                            <!-- Quick quote -->

                            @case (45) {
                                <a
                                    sfButton
                                    icon="cog"
                                    [tooltip]="processTooltip"
                                    size="sm"
                                    href="{{ legacyUrl }}QuickQuote/Edit/{{ post.t1 }}"
                                    target="_blank"
                                    >Process</a
                                >
                            }
                            <!-- Spares quote -->
                            @case (44) {
                                <a
                                    sfButton
                                    icon="cog"
                                    [tooltip]="processTooltip"
                                    size="sm"
                                    href="{{ legacyUrl }}PartsArena/Edit/{{ post.t1 }}"
                                    target="_blank"
                                    >Process</a
                                >
                            }
                            <!-- Smart quote -->
                            @case (73) {
                                <a
                                    sfButton
                                    icon="cog"
                                    [tooltip]="processTooltip"
                                    size="sm"
                                    routerLink="/smartquote/{{ post.t1 }}"
                                    target="_blank"
                                    >Process</a
                                >
                            }
                            <!-- Smart quote -->
                            @case (74) {
                                <a
                                    sfButton
                                    icon="cog"
                                    [tooltip]="processTooltip"
                                    size="sm"
                                    routerLink="/smartquote/{{ post.t1 }}"
                                    target="_blank"
                                    >Process</a
                                >
                            }
                            @default {
                                <a
                                    sfButton
                                    icon="cog"
                                    [tooltip]="processTooltip"
                                    size="sm"
                                    routerLink="/posts/{{ post.id }}"
                                    >Process</a
                                >
                            }
                        }

                        <div class="btn-group" ngbDropdown role="group" aria-label="Button group with nested dropdown">
                            <button
                                sfButton
                                type="button"
                                size="sm"
                                color="secondary"
                                class="dropdown-toggle-split"
                                ngbDropdownToggle></button>
                            <div class="dropdown-menu" ngbDropdownMenu>
                                @if (post.isVoided) {
                                    <button
                                        sfButton
                                        ngbDropdownItem
                                        tooltip="Mark this post as Unvoided"
                                        (click)="postStore.setPostVoid({ postId: post.id, isVoid: false })">
                                        Unvoid
                                    </button>
                                } @else {
                                    <button
                                        sfButton
                                        ngbDropdownItem
                                        tooltip="Mark this post as Voided"
                                        (click)="postStore.setPostVoid({ postId: post.id, isVoid: true })">
                                        Void
                                    </button>
                                }
                                <button
                                    sfButton
                                    ngbDropdownItem
                                    tooltip="Remove this post (will mark the post as Processed)"
                                    (click)="postStore.removePost(post.id)">
                                    Remove
                                </button>
                                <button
                                    sfButton
                                    ngbDropdownItem
                                    tooltip="Delete this post will remove it from your database (irreversable)"
                                    (click)="deletePost()">
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #processTooltip>
        View the 'Process Post' screen to view the post details and email the certificate to the customer
    </ng-template>
}
